// extracted by mini-css-extract-plugin
export var details = "course-details-module--details--SvjYi";
export var title = "course-details-module--title--vtFya";
export var description = "course-details-module--description--xbZop";
export var imageAndTeacherListSection = "course-details-module--imageAndTeacherListSection--PrJ45";
export var imageWrapper = "course-details-module--imageWrapper--BsaGZ";
export var image = "course-details-module--image--puyZj";
export var listWrapper = "course-details-module--listWrapper--o3qd6";
export var list = "course-details-module--list--8BSjc";